import {SecureTable} from '../secure.table';
import {CdAimEvaluation} from '../../interfaces/care/cd-care-plan/cd-aim-evaluation';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {CdAimEvaluationFactory} from '../../factories/care/cd-care-plan/cd-aim-evaluation-factory';
import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class CdAimEvaluationsTable extends SecureTable<CdAimEvaluation> {
  constructor() {
    super(db.cdAimEvaluations);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<CdAimEvaluation>({
        api: ['care', 'c-evaluations'],
        foreignKey: 'cdAddedAimId',
        fromObject: CdAimEvaluationFactory.fromObject,
        toRemote: CdAimEvaluationFactory.toRemote,
      })
    };
  }

  /**
   *
   * @param cdAddedAimIds
   * @param force
   */
  public async removeByCdAddedAimIds(cdAddedAimIds: number[], force: boolean = false): Promise<void> {
    const cdAimEvaluations = await this.getByCdAddedAimIds(cdAddedAimIds);
    await this.removeMany(cdAimEvaluations.map(_cdAimEvaluation => _cdAimEvaluation.uuid), force);
  }

  /**
   *
   * @param cdAddedAimIds
   */
  public async getByCdAddedAimIds(cdAddedAimIds: number[]): Promise<CdAimEvaluation[]> {
    return this.table.where('cdAddedAimId').anyOf(cdAddedAimIds).toArray();
  }

}
